/**
 * useEntitlements - Resolves the active tenant's plan entitlements.
 *
 * Backs feature-gating across the app (e.g. hiding nav items the tenant's
 * plan doesn't include). Reads from GET /api/tenants/me/entitlements via the
 * tenant-scoped query wrapper, which injects auth + tenant headers and adds
 * the `/api` prefix automatically.
 */

import { useTenantQuery } from './useTenantQuery';

export interface Entitlements {
  planKey: string | null;
  features: string[];
  limits: Record<string, number>;
}

export function useEntitlements() {
  const { data } = useTenantQuery<Entitlements>(['entitlements'], '/tenants/me/entitlements', {
    staleTime: 5 * 60 * 1000,
  });

  const features = data?.features ?? [];

  return {
    features,
    hasFeature: (f: string) => features.includes(f),
    limits: data?.limits ?? {},
  };
}
